import MenuItem from '@mui/material/MenuItem';
import FileSaver from 'file-saver';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { collectionApis } from '../../../apis/collectionApis';
import useToast, { TOAST_TYPE } from '../../../hooks/useToast';
import { sentenceCase } from '../../../utils/utils';

const ExportMenuItem = ({ name, onClose }) => {
  const { projectId, instanceId } = useParams();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const handleExport = async () => {
    try {
      const exportRes = await collectionApis.exportCollection(
        projectId,
        instanceId,
        name
      );
      showToast(
        TOAST_TYPE.SUCCESS,
        sentenceCase(
          t('exportSuccess', {
            ns: 'notifications',
            text: t('collection', { ns: 'instance' }),
          })
        )
      );
      const blob = new Blob([exportRes.data], {
        type: 'application/zip',
      });
      FileSaver.saveAs(blob, `${name}.zip`);
    } catch (error) {
      showToast(
        TOAST_TYPE.ERROR,
        `${sentenceCase(
          t('exportError', {
            ns: 'notifications',
            text: t('collection', { ns: 'instance' }),
          })
        )} ${error.message}`
      );
    } finally {
      onClose();
    }
  };

  return (
    <MenuItem onClick={handleExport}>{t('export', { ns: 'buttons' })}</MenuItem>
  );
};

ExportMenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ExportMenuItem;
